<template>
<svg class="custom-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
        <path d="M14.5,1C6.505,1,0,7.505,0,15.5S6.505,30,14.5,30S29,23.495,29,15.5S22.495,1,14.5,1z M14.5,5c2.206,0,4,1.794,4,4
            s-1.794,4-4,4c-2.206,0-4-1.794-4-4S12.294,5,14.5,5z M22,24H7c-0.276,0-0.5-0.224-0.5-0.5c0-4.687,3.589-8.5,8-8.5s8,3.813,8,8.5
            C22.5,23.776,22.276,24,22,24z" />
    </svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
